import React from 'react';
import Alert from '@mui/material/Alert';
import { styled } from '@mui/material/styles';

const StyledAlert = styled(Alert)(() => ({
    position: 'fixed',
    top: '80px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 9999,
    minWidth: '300px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    borderRadius: '8px',
    '& a': {
        color: 'inherit',
        textDecoration: 'underline',
        '&:hover': {
            textDecoration: 'none'
        }
    }
}));

function AlertMessage({ show, onClose, message, link }) {
    if (!show) return null;

    const renderMessage = () => {
        if (link) {
            return (
                <>
                    {message} {' '}
                    <a href={link} target="_blank" rel="noopener noreferrer">
                        нашому телеграм боті
                    </a>
                </>
            );
        }
        return message;
    };

    return (
        <StyledAlert
            severity="error"
            onClose={onClose}
        >
            {renderMessage()}
        </StyledAlert>
    );
}

export default AlertMessage;
